import {
  Box,
  Button,
  CircularProgress,
  Fab,
  GlobalStyles,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import ReactDragListView from "react-drag-listview/lib/index";
import { GET_CITIE } from "../../../Apis/city_api";
import {
  DELETE_PRAMOTIONAL_BANNER,
  GET_PRAMOTIONAL_BANNER,
  REORDER_PRAMOTIONAL_BANNER,
} from "../../../Apis/pramotional_banner_api";
import AddBanner from "../../../Component/Dailog/AddBannerDailog";
import { API_URL } from "../../../Apis/config";
import {
  Delete,
  DragIndicator,
  Edit,
  Link as LinkIcon,
} from "@mui/icons-material";
import ConfirmationDailog from "../../../Component/Dailog/ConfirmationDailog";
import MultiSelection from "../../../Component/Multiselection/MultiSelection";
import { ToastShow } from "../../../Component/Toast/Toast";

const CARD_WIDTH = 300;
const IMAGE_HEIGHT = 170;

const overlayButtonSx = {
  bgcolor: "rgba(255, 255, 255, 0.85)",
  color: "#333",
  "&:hover": { bgcolor: "#fff" },
};

function PamotionalBanner() {
  const [cities, setCities] = React.useState([]);
  const [citiesW, setCitiesW] = React.useState([]);
  const [selectedCities, setSelectedCities] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isCall, setIsCall] = React.useState(true);
  const [cityId, setSelectedId] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [openConfirmation, setOpenConfirmation] = React.useState(false);
  const [bannerId, setBannerId] = React.useState(0);
  const [src, setSrc] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [isOrderChanged, setIsOrderChanged] = React.useState(false);
  const [isSavingOrder, setIsSavingOrder] = React.useState(false);

  const canReorder = rows.length > 1;

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (fromIndex === toIndex || toIndex < 0) {
        return;
      }
      const data = [...rows];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      setRows(data);
      setIsOrderChanged(true);
    },
    nodeSelector: ".banner-card",
    handleSelector: ".banner-drag-handle",
    lineClassName: "banner-drag-line",
  };

  const handleSaveOrder = async () => {
    setIsSavingOrder(true);
    const banners = rows.map((v, index) => ({ id: v.id, ordr: index + 1 }));
    const d = await REORDER_PRAMOTIONAL_BANNER(cityId, banners);
    setIsSavingOrder(false);
    if (d && d.s == 1) {
      ToastShow("Banner order saved");
      getData(cityId, 0);
    } else {
      ToastShow(d?.m ?? "Opps! something went wrong. Please try again.");
    }
  };

  const handleOpen = (v = 0, src = "", url = "") => {
    if (v) {
      setSrc(src);
      setUrl(url);
      setBannerId(v);
    }
    setOpen(true);
  };

  const handleOpenConfirmation = (id) => {
    setBannerId(id);
    setOpenConfirmation(true);
  };

  const handleOnClose = (v) => {
    setSrc("");
    setUrl("");
    setBannerId(0);
    if (v) {
      getData(cityId, 0);
    }
    setOpen(0);
  };

  const handleOnCloseConfirmation = async (v) => {
    if (v) {
      const d = await DELETE_PRAMOTIONAL_BANNER(bannerId);
      if (d && d.s) {
        ToastShow("Deleted successfully");
      }
      setBannerId(0);
      getData(cityId, 0);
    }
    setOpenConfirmation(0);
  };

  async function getCities() {
    const t = await GET_CITIE();

    if (t && t.s == 1) {
      setCitiesW([...t.r]);
      const c = [];
      for (const v of t.r) {
        c.push(v.name);
      }
      setCities([...c]);
      setSelectedId(t.r[0].id);
      setSelectedCities([t.r[0].name]);
      getData(t.r[0].id, 0);
    }
  }

  const callBack = (l) => {
    if (l >= rows.length && isCall) {
      getData(cityId, 1);
    }
  };

  const handleSelectCity = async (e) => {
    const {
      target: { value },
    } = e;

    setSelectedCities([value]);
    const c = citiesW.filter((v) => v.name == value);
    setSelectedId(c.length ? c[0].id : 0);
    await getData(c.length ? c[0].id : 0, 0);
  };

  async function getData(id, v) {
    if (!v) {
      setIsCall(true);
      setIsOrderChanged(false);
    }
    setIsLoading(true);
    const t = await GET_PRAMOTIONAL_BANNER(v ? rows.length : 0, id);

    if (t && t.s == 1) {
      if (v) {
        setRows([...rows, ...t.r]);
      } else {
        if (t.r == null) {
          setRows([]);
        } else {
          setRows([...t.r]);
        }
      }
    }

    if ((t.r ?? []).length == 0) {
      setIsCall(false);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getCities();
  }, []);

  return (
    <Box
      sx={{
        overflowY: "auto",
        height: "80vh",
      }}
    >
      {/* Drop indicator line drawn by react-drag-listview (appended to <body>) */}
      <GlobalStyles
        styles={(theme) => ({
          ".banner-drag-line": {
            position: "absolute",
            height: "4px",
            marginTop: "-2px",
            borderRadius: "2px",
            backgroundColor: theme.palette.primary.main,
            zIndex: theme.zIndex.modal,
            pointerEvents: "none",
          },
        })}
      />

      {/* Toolbar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          px: 2,
          pt: 1,
        }}
      >
        <MultiSelection
          multiple={false}
          names={cities}
          handleChange={handleSelectCity}
          selected={selectedCities}
          lable="Cities"
        />

        {!isLoading || rows.length ? (
          <Typography variant="body2" color="text.secondary">
            {rows.length} {rows.length === 1 ? "banner" : "banners"}
          </Typography>
        ) : null}

        <Box sx={{ flexGrow: 1 }} />

        {isOrderChanged ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.5,
              py: 0.5,
              borderRadius: 2,
              bgcolor: "action.hover",
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Order changed
            </Typography>
            <Button
              size="small"
              onClick={() => getData(cityId, 0)}
              disabled={isSavingOrder}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleSaveOrder}
              disabled={isSavingOrder}
              startIcon={
                isSavingOrder ? (
                  <CircularProgress size={14} color="inherit" />
                ) : null
              }
            >
              Save order
            </Button>
          </Box>
        ) : canReorder ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <DragIndicator fontSize="small" sx={{ mr: 0.5 }} />
            Drag to reorder banners for this city
          </Typography>
        ) : null}
      </Box>

      {/* Loading / empty states */}
      {isLoading && rows.length === 0 ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress size={32} />
        </Box>
      ) : null}

      {!isLoading && rows.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 8 }}>
          <Typography color="text.secondary">
            No banners for this city yet.
          </Typography>
          <Button
            startIcon={<AddIcon />}
            onClick={() => handleOpen()}
            sx={{ mt: 1 }}
          >
            Add banner
          </Button>
        </Box>
      ) : null}

      {/* Banner grid */}
      <ReactDragListView {...dragProps}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 3,
            p: 2,
            pb: 12,
          }}
        >
          {rows.map((v, index) => {
            return (
              <Box
                key={v.id}
                className="banner-card"
                sx={{
                  position: "relative",
                  width: `${CARD_WIDTH}px`,
                  borderRadius: 2,
                  overflow: "hidden",
                  bgcolor: "background.paper",
                  boxShadow: 3,
                  transition: "box-shadow 200ms, transform 200ms",
                  "&:hover": {
                    boxShadow: 8,
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box
                  sx={{
                    height: `${IMAGE_HEIGHT}px`,
                    bgcolor: "action.hover",
                    cursor: v.url ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (v.url) {
                      window.open(v.url, "_blank");
                    }
                  }}
                >
                  <img
                    alt={`Banner ${index + 1}`}
                    src={API_URL.baseUrl + API_URL.bannerImage + v.file}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </Box>

                {/* Position + drag handle */}
                <Tooltip title={canReorder ? "Drag to reorder" : ""}>
                  <Box
                    className="banner-drag-handle"
                    sx={{
                      position: "absolute",
                      top: 8,
                      left: 8,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.25,
                      pl: canReorder ? 0.25 : 1,
                      pr: 1,
                      height: 30,
                      borderRadius: 15,
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: canReorder ? "grab" : "default",
                      userSelect: "none",
                      ...overlayButtonSx,
                    }}
                  >
                    {canReorder ? <DragIndicator fontSize="small" /> : null}
                    {index + 1}
                  </Box>
                </Tooltip>

                {/* Actions */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    gap: 1,
                  }}
                >
                  <Tooltip title="Edit">
                    <IconButton
                      size="small"
                      onClick={() => handleOpen(v.id, v.file, v.url ?? "")}
                      sx={overlayButtonSx}
                    >
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenConfirmation(v.id)}
                      sx={overlayButtonSx}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Link */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 1.5,
                    height: 40,
                  }}
                >
                  <LinkIcon
                    fontSize="small"
                    color={v.url ? "primary" : "disabled"}
                  />
                  {v.url ? (
                    <Tooltip title={v.url}>
                      <Typography
                        variant="body2"
                        noWrap
                        component="a"
                        href={v.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="primary"
                        sx={{ textDecoration: "none" }}
                      >
                        {v.url}
                      </Typography>
                    </Tooltip>
                  ) : (
                    <Typography variant="body2" color="text.disabled">
                      No link
                    </Typography>
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      </ReactDragListView>

      <Box>
        <Tooltip title="Add banner">
          <Fab
            color="primary"
            onClick={() => handleOpen()}
            sx={{
              position: "absolute",
              bottom: 30,
              right: 30,
            }}
          >
            <AddIcon />
          </Fab>
        </Tooltip>

        {open ? (
          <AddBanner
            cities={cities}
            citiesW={citiesW}
            cityId={cityId}
            open={open}
            id={bannerId}
            handleOnClose={handleOnClose}
            src={src}
            urls={url}
          />
        ) : null}

        {openConfirmation ? (
          <ConfirmationDailog
            open={openConfirmation}
            handleOnClose={handleOnCloseConfirmation}
          />
        ) : null}
      </Box>
    </Box>
  );
}

export default PamotionalBanner;
